'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withPadding = require('../with-padding');

var _withPadding2 = _interopRequireDefault(_withPadding);

var _withBorder = require('../with-border');

var _withBorder2 = _interopRequireDefault(_withBorder);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./tile.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Tile(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['className', 'children']);

  var classes = (0, _classnames2.default)('tile', className);

  return _react2.default.createElement(
    'div',
    _extends({ className: classes }, props),
    children
  );
}

Tile.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};

Tile.defaultProps = {
  padding: 'medium'
};

exports.default = (0, _withPadding2.default)((0, _withBorder2.default)(Tile), { padding: 'medium' });